'use client'

import { cn } from '@qr-front/ui/utils'

import { TErrorPageHandledCode, useErrorCode } from './useErrorCode'

interface IllustrationTextProps {
	code?: TErrorPageHandledCode
}

export const IllustrationText = ({
	code: overrideCode,
}: IllustrationTextProps = {}) => {
	const detectedCode = useErrorCode()
	const code = overrideCode || detectedCode

	const codeTextSize = code === '404' ? '36%' : '39%'

	return (
		<foreignObject x={codeTextSize} y={codeTextSize} width={300} height={191}>
			<span
				className={cn(
					'type-heading-0',
					code === '403' && 'type-heading-0 desktop:type-heading-1',
				)}
			>
				{code}
			</span>
		</foreignObject>
	)
}
